import Slider from '../services/sliderService';

const preloadedZoomSources = new Set();

function preloadActiveSlideZoom(swiper) {
    const slide = swiper.slides?.[swiper.activeIndex];
    if (!slide) return;

    const img = slide.querySelector('img[data-zoom-src]');
    const url = img?.dataset.zoomSrc;
    if (!url || preloadedZoomSources.has(url)) return;

    preloadedZoomSources.add(url);
    const preload = new Image();
    preload.src = url;
}

export default function gallerySlider() {
    const elements = document.querySelectorAll('.js-gallery-slider');

    elements.forEach((element) => {
        const wrapper = element.closest('.gallery-slider');

        const options = {
            slidesPerView: 1,
            spaceBetween: 0,
            zoom: {
                maxRatio: 2,
                toggle: true,
            },
            pagination: {
                el: wrapper.querySelector('.js-gallery-slider-pagination'),
                type: 'fraction',
            },
            wrapperElement: wrapper,
            on: {
                init(swiper) {
                    Slider.attachFocusHandler(swiper);
                    preloadActiveSlideZoom(swiper);
                },
                slideChangeTransitionEnd(swiper) {
                    preloadActiveSlideZoom(swiper);
                },
                zoomChange(swiper, scale, imageEl) {
                    const zoomed = scale > 1;
                    const instance = swiper;

                    instance.allowTouchMove = !zoomed;
                    instance.allowSlideNext = !zoomed;
                    instance.allowSlidePrev = !zoomed;

                    wrapper.classList.toggle('gallery-slider--zoomed', zoomed);

                    const target = imageEl;
                    if (zoomed && target?.dataset?.zoomSrc && target.src !== target.dataset.zoomSrc) {
                        target.removeAttribute('srcset');
                        target.src = target.dataset.zoomSrc;
                    }
                },
            },
        };

        // eslint-disable-next-line no-new
        new Slider(element, options);
    });
}
